/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Chart_TitleInputs */

const vi_report_chart_title = /** @type {(inputs: Report_Chart_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doanh thu theo thời gian`)
};

/**

* @param {Report_Chart_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_chart_title = /** @type {((inputs?: Report_Chart_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Chart_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_chart_title(inputs)
});